import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { SignatureService } from 'src/app/services/signature.service';
import { LocalStorageUtil } from 'src/app/util/local-storage-util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-beta-payment',
  templateUrl: './beta-payment.component.html',
  styleUrls: ['./beta-payment.component.scss']
})
export class BetaPaymentComponent implements OnInit {
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private signatureService: SignatureService
  ) { }
  token: string;

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('valid');
    this.loginBeta(this.token);
  }

  async loginBeta(token: string){
    this.loginService.loginBetaApp(token).subscribe({
      next: (data) => {
        LocalStorageUtil.setToken(data.accessToken);
        this.loginService.startIntercom(data.accountInfo);

        
        //Signature
        this.signatureService.getAccountSignature().subscribe(
          (signature) => {
            LocalStorageUtil.setAccountInfo(data.accountInfo);

            if (signature && signature.data && signature.data.suspended) {
                this.router.navigate(['/signature']);
            } 
            
            this.router.navigate(['/v2/indications']);
            
          }
        )
      },
      error: (err) => {
        console.log("Erros recebidos", err)

        //Se for Unauthorized envia para app.previdas
        window.location.href = environment.stableUrl;

      }
    }) 
  }

}
